import { createFileRoute } from "@tanstack/react-router";
import ClientsListPage from "@/components/settings/clients/clients-list-page";

export const Route = createFileRoute("/_app/settings/clients/")({
	component: ClientsListPage,
});
